//中文
export default {
  login: {
    lang:'语言',
    tradeRole: '贸易角色',
    account: '账号',
    password: '密码',
    verificationCode: '验证码',
    login: '登录',
    email: '邮箱',
    forgetPwd: '忘记密码',
    resetPassword: '重置密码',
    logout: '退出登录',
    oldPassword: '旧密码',
    newPassword: '新密码',
    confirmNewPassword: '确认新密码',
    cancel: '取消',
    confirm: '确定',
    passwordIncorrectAgain: '输入密码不一致，请重新输入',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseEnterOldPassword: '请输入旧密码',
    tips: '提示',
    savedSuccessfully: '保存成功',
    submittedSuccessfully: '提交成功',
    logoutSuccessful: '登出成功',
    resetSuccessfullyAgain: '重置成功，请重新登录',
    serverNotRsponding: '暂无响应，请联系管理员',
    return: '返回',
    send: '发送',
    sendCode: '发送验证码',
    PleaseEnterUsername: '请输入账号',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterVerification: '请输入验证码',
    pleaseEnterEmail: '请输入邮箱',
    pleaseReenterPassword: '请再次输入新密码',
    passwordResetLogin: '密码重置成功，请重新登录',
    pleaseResetPassword: '新用户请初始化密码',
    verificationSentInbox: '验证码已发送，请查收',
    noCompanyFoundContact: '您暂无企业，请联系运营人员协助处理，谢谢',
    onboardingStatusAbnormal: '建档状态异常，请联系管理员',
    loginAgain: '重新登录',
    noPermission: '暂无权限，请联系管理员',
    pswValidatePopover: {
      title: '密码必须满足：',
      rule1: '长度为 12-15 个字符',
      rule2: '1个大写字母',
      rule3: '1个小写字母',
      rule4: '1个数字和特殊字符',
    },
    pswNotSame: '确认新密码与新密码不一致',
    //请输入6位数字验证码
    pleaseEnterSixDigitVerificationCode: '请输入6位数字验证码',
    verificationCodeError: '验证码错误',
    serviceUnavailable: '服务暂时不可用，请稍后再试',
    signUp: '注册',
    title: '让我们开始吧!',
    noAccount: '没有账号？点击 ',
    hasAccount: '已有账号？点击 ',
    hasAgree: '我已阅读，同意并接受',
    agreement: '《用户协议》和《隐私条款》',
    register: {
      companyName: '企业名称',
      name: '联系人',
      firstName: '名',
      lastName: '姓',
      email: '登录邮箱',
      phone: '手机号',
      password: '密码',
      success: '注册成功',
      emailCode: '邮箱验证码',
      resetPwd: '密码重置成功，请重新登录',
      verificationCode: '验证码已发送，请查收',
    },
    pwdRule: {
      ruletit: '密码必须包含：',
      rule1: '长度至少 8 个字符',
      rule2: '1 个大写字母',
      rule3: '1 个小写字母',
      rule4: '1 个数字和符号',
      ruleTip: '为了提升安全性，请避免使用其他网站的密码。',
    },
    jsCheck: {
      telephone:'请输入手机号',
      phoneAreaCode:'请选择区号',
      email: '请输入邮箱',
      emailFormat: '邮箱格式错误',
      phone: '请输入手机号',
      phoneFormat: '手机号格式错误',
      confirmPwd: '请再次输入新密码',
      differentPwd: '再次输入新密码与新密码不一致',
      password: '请输入密码',
      verCode: '请输入验证码',
      name: '请输入联系人',
      firstName: '请输入名',
      lastName: '请输入姓',
      newPwd: '请输入新密码',
      companyName: '请输入企业名称',
      passwordFormat: '密码格式错误'
    },
    changePassword: '重置密码',
    loginTitle: '登录您的账户',
    agree: '我已阅读，同意并接受',
    userAgreement: '《用户协议》',
    privacyPolicy: '《隐私条款》',
    and: '和',
    forgetPassword: '忘记密码?',
    registerNow: '立即注册',
    loginNow: '立即登录',
  },
  common: {
    back: '返回',
    Select:'请选择',
    inputPlaceholder: '请输入',
    selectPlaceholder: '请选择',
    documents: '上传文件',
    pleaseUploadClear:
      '(请上传清晰、完整、无遮挡物的图片，支持 .pdf, .jpeg, .jpg, .png 文档)',
    name: '姓名',
    email: '电子邮箱',
    phoneNo: '手机号码',
    positionCompany: '公司职位',
    IDType: '证件类型',
    IDNo: '证件编号',
    plSelect: '请选择',
    IDDocFront: '证件正面照',
    IDDocBack: '证件反面照',
    countdownMarketClosure: '闭市截止时间',
    hour: '小时',
    minute: '分钟',
    second: '秒',
    signedSuccessfully: '签署成功',
    startPlaceholder: '开始日期',
    endPlaceholder: '结束日期',
    companyIdentCodePlaceholder: "只需要输入登记证号码前8位",
    sample: "示例",
    certificateFront: '证件（正面）',
    certificateBack: '证件（反面）',
    delete: '删除',
    "fileLimitWarning": "您只能上传 {limit} 个文件。"
  },
  tips: {
    agreedFollowingTerms: '1、你同意本平台服务协议的以下条款；',
    constitutesElectronicSignature:
      '2、为《电子交易条例》（香港法律第553章）之目的，该行为构成你对本平台服务协议的电子签署。',
    clickingButtonConfirm: '通过点击此按钮，你同意并确认:',
    clickAgreeConfirm: '请点击按钮，同意并确认',
    needAgreementSigning: '您需要阅读完成整个协议再签署，谢谢配合。',
    confirmToSign: '确定签署',
    selectCompanyLogin: '请选择登陆企业',
    agreementFirstPlatformServices:
      '您好，您尚未签署平台服务协议，为更好地给您提供完整的平台服务，您需要先签署该协议',
  },
  enterprise: {
    tellYourCompany: '企业信息',
    companyInfo: '基本信息',
    companyNameChinese: '企业中文名称',
    companyNameEnglish: '企业英文名称',
    companyDocsType: '企业证件类型',
    companyDocsNo: '企业证件编号',
    countryIncorporation: '注册国家/地区',
    registeredCity: '注册省市',
    registeredCityElse: '注册城市',
    registeredAddress: '注册详细地址',
    certificateIncorporation: '公司注册证书正面照',
    companyDocsArticlesOrganization: '公司章程、股权架构等其他资料',
    businessLicence: '营业执照正面照',
    businessRegistration: '商业登记证正面照',
    incorporationForm: '法团成立表格正面照',
    tellAboutYourself: '授权人信息',
    sameAuthorizedPerson: '与授权人信息相同',
    whoBeneficialOwner: '受益人信息',
    BONaturalPerson:
      '受益人是：对企业的资产拥有25%或以上直接或间接股权关系的自然人，或 持有在股东大会上25%或以上表决权的自然人。',
    addBeneficialOwner: '添加受益人',
    deleteBeneficiaryOwner: '删除受益人',
    beneficialOwner: '受益人',
    tellYourBankAccount: '账户信息',
    account: '账户',
    deleteAccount: '删除账户',
    addAccount: '添加账户',
    currency: '账户币种',
    bankAccountType: '银行账户类型',
    accountName: '账户名',
    bankAccountNo: '银行账号',
    bankName: '开户银行',
    bankCountry: '开户国家',
    bankCity: '开户城市',
    CNAPSCode: '联行行号',
    branchName: '所在支行',
    bankSWIFTBIC: '开户行swift code',
    intermediaryBankSWIFTBIC: '中转行swift code',
    eSignatureSubmit: '签署及提交',
    pleaseDownloadDocument: '请下载并签署文件',
    pleaseUploadDocument: '请将已签署的文件上传至下方',
    download: '下载',
    companyInformation: '企业信息',
    personnalInformation: '关联人信息',
    accountInformation: '账号信息',
    previous: '上一步',
    save: '保存',
    next: '下一步',
    submit: '提交',
    fileUploadedSuccessfully: '上传文件成功',
    deleteSuccessfully: '删除成功',
    dragFilesHere: '将文件拖到此处，或',
    browse: '点击上传',
    supportFormat: '(每个文件 < 20MB,支持JPG,PDF 和 PNG格式)',
    authenticationFailed: '认证失败',
    retry: '重试',
    legalRepresentative: '法人',
    director: '董事',
    info: '信息',
    deleteDirector: '删除董事',
    addDirector: '添加董事',
    success: '提交成功',
    ourTeamReviewInformation: '我们的团队将会审查您的信息，',
    sendConfirmationEmail: '您将在提交后24小时内收到确认电邮。',
  },
  bigHome: {
    digitalFinance: '数字金融',
    digitalFinanceContent: '创新的供应链融资方式',
    digitalTrade: '数字贸易',
    digitalTradeContent: '人工智能+区块链，赋能国际贸易',
    pendingTasks: '待办',
    linklogisInternational: '联易融国际',
    linklogisInternationalContent:
      '致力于为全球银行和企业提供一流的数字供应链融资服务',
    downloadManagement: '下载管理',
    No: '序号',
    fileName: '文件名',
    status: '导出状态',
    createTime: '创建时间',
    action: '操作',
    download: '下载',
    topNotice:'联易融国际重塑品牌为 Unloq，开启全球增长新篇章，请点击<a href="' + (["https://cbf-my.wellschain.com","https://cbf-my.unloq.com","https://app.unloq.com","https://app.linklogis.com.hk","https://cbf-my.linklogis.com.hk"].includes(location.origin) ? "https://www.unloq.com/AboutUs" : "https://unloqx.hrlyit.com/AboutUs") + '" target="_blank" style="text-decoration: underline;">此处</a>查阅更多详情。'
  },
  menu: {
    moreProduct: '更多产品',
  },
  contract: {
    title: '电子债权凭证产品和服务协议',
    download: '下载模板',
    submit: '提交',
    downloadAndSignfiles: '下载并签署文件',
    uploadTheSignedDocument: '请将已签署的文件上传',
    cfcaDigital: '《CFCA数字证书服务协议》',
    checkThisBox: '通过勾选此框及点击“提交”，您同意签署',
    pleaseCheck: 'Please check the "CFCA Digital Certificate Service"',
  },
  cfcaAgreement: {
    title: 'CFCA电子认证服务协议',
    checkPrefix: '我已阅读完成并同意',
    linkText: 'CFCA电子认证服务协议',
    tipScrollToBottom: '请务必阅读该协议全文，滚动到最底部后方可勾选此复选框',
    tipReadSeconds: '为了确保您已充分了解协议内容，请再阅读约{sec}秒',
    cancel: '取消',
    confirmSigning: '确认签署',
    msgScrollToBottom: '请先将协议内容滚动至底部',
    msgReadMoreSeconds: '为了确保您已充分了解协议内容，请再阅读约 {sec} 秒',
    msgPleaseCheck: '请先勾选“我已阅读完成并同意”后再签署',
  },
  downloadMgm: {
    fileName: '文件名',
    status: '打包状态',
  },
  productCenter: {
    marketplace: '资产交易平台',
    marketplaceDes:'提供多样化的资产选择，实现高效交易匹配，并以此获得可观的收益。',
    exportDrawback: '出口退税',
    digitalFinance: '供应链融资',
    digitalPayment: '跨境支付',
    DTT: '数字贸易代币',
    DTTDes:'一个数字贸易代币支付平台，可实现钱包创建、跨境结算，并与多个区块链网络无缝集成，以支持全球数字资产交易。',
    exportDrawbackDes:
      '全自动采集单证数据，智能匹配关单发票，闪电退税，为您提供一站式出口退税综合服务。',
    digitalFinanceDes:
      '提供各类融资产品，全线上、低利率、放款快，解决您短期的资金需求。',
    digitalPaymentDes:
      '为进出口企业提供跨境账户服务，轻松完成境外开户、收付款、换汇及结汇提现，高效利用资金，助力跨境交易快捷、安全。',
    activate: '开通产品',
    useNow: '前往使用',
    freeTrial: '免费试用中',
    subscribeNow: '立即付费',
    inactive: '未开通',
    underReview: '审核中',
    failed: '开通失败',
    active: '已开通',
    productActivation: '产品开通',
    productActivationDes:
      '您的产品开通请求已收到，请直接联系您的客户经理进行相关操作，请耐心等待。',
    scanCode: '微信扫码添加管理员进行付费并解锁专家指导',
    product: '产品',
    productCenter: '产品中心',
    verify: '开始认证',
    kycStatus: '当前有未完成KYC 流程'
  },
  exportDrawbackKyc: {
    des1: '请完善贵公司的基本信息，快速开通出口退税产品',
    des2: '请填写被授权人的基本信息，以便工作人员认证',
    des3: '请上传授权确认书',
    enterComInfo: '请填写相关的企业基本信息',
    enterUserInfo: '请填写被授权人信息',
    uploadBusinessLicense: '请上传营业执照',
    businessLicenseTip:
      '请确保上传资料文字清晰可见，最大不超过10M，格式限定为pdf、jpg、jpeg、png、bmp',
    lastName: '姓',
    firstName: '名',
    businessEmail: '邮箱',
    contactNo: '手机号码',
    idNo: '身份证号码',
    idNoFormat: '身份证号格式错误',
    companyName: '企业名称',
    usci: '企业统一社会信用代码',
    businessType: '企业类型',
    manuCompany: '生产型企业',
    tradeCompany: '外贸型企业',
    updateUserTitle: '更新登录用户',
    updateUserTip1:
      '被授权人信息与系统留存登录用户信息不一致，请确认是否更新登录用户信息？',
    updateUserTip2: '点击确认，您的登录账号将更新为被授权人的邮箱或手机。',
    download: '下载模板',
    protocolTip: '通过勾选此框及点击“提交”，您统一签署',
    pass: '跳过',
    next: '下一步',
    prev: '上一步',
    confirm: '确认',
    submit: '提交',
    annualReportTip: '请上传周年报或法团成立表'
  },
  kycFile: {
    kycUpload: {
      dropFile: '拖拽文件到此处或者',
      browse: '浏览',
      tip:
        '请确保上传资料文字清晰可见，最大不超过10M，格式限定为pdf、jpg、jpeg、png、bmp',
      fileTypeMust: '文件必须为.pdf .jpg .jpeg .png .bmp类型',
      fileSizeNotExceed: '文件大小不能超过10M，请重新上传',
    },
    basicsInfo: {
      atLeastEightchar:'需填入至少8位字符',
      requireEighteenChar:'需填入18位字符',
      tit: '请填写贵公司的基本信息，以便工作人员认证',
      titTwo: '请上传贵公司的注册文件，并填写相关的企业基本信息',
      uploadBusinessLicense: '请上传贵公司的营业执照',
      uploadRegistrationCertificate: '请上传公司注册证书',
      otherEnterpriseFile: '其它文件',
      constitutionFile: '请上传公司章程',
      businessFile: '请上传商业登记证',
      financialFile:"请上传财报",
      saleFile: '请上传销售清单',
      equityFile: '请上传股权架构图(需要任意公司董事在最近3个月内签署)',
      companyNameEn: '企业英文名称',
      nameTip: "支持大小写字母，数字以及/ - ? : ().,'",
      companyNameCn: '企业名称',
      blodTip:
        '请填写贵公司的注册地址（在政府机构注册的正式地址）和经营地址（公司经营业务的实际地点）。它们可以是相同或不同的。',
      regCountry: '注册国家或地区',
      regCountryTip: '经营地址与注册地址一致',
      regAddress: '注册地址',
      opeCountry: '经营国家或地区',
      opeAddress: '经营地址',
      companyTip: '请上传贵公司注册相关的文件。',
      companyType: '企业类型',
      companyTypeItem1: '一般纳税人',
      companyTypeItem2: '小规模企业',
      companyCode: '企业证件编号',
      companyStartDate: '企业证件有效期开始日期',
      companyEndDate: '企业证件有效期结束日期',
      companyDateEver: '永久有效',
      companyCredentias: '企业证件类型',
      institutionalType: '机构类型',
      companyNameEnTip: '企业英文名称格式或长度错误',
      issuedPlaceOfCertificate: '企业证件签发地',
      issuedPlaceOfCertificateTip: '请选择企业证件签发地',
      companyCodeTip: '企业证件编号格式错误',
      regAddressTip: '注册地址格式错误',
      opeAddressTip: '经营地址格式错误',
      annualReport: '周年报或法团成立表',
      province: '省',
      city: '市',
      street: '街道',
      operatingProvince: '经营省',
      operatingCity: '经营市',
      operatingStreet: '经营街道',
      industry: '行业',
      companySize: '公司规模'
    },
    identityInfo: {
      tit: '需要得到法人的同意才能开立账户。请告诉我们贵公司主要法人的身份',
      titSec: '需要得到董事的同意才能开立账户。请告诉我们贵公司主要董事的身份',
      identities: '请选择你所有的身份(可多选)',
      infomation: '请填写本人信息',
      familyName: '姓',
      firstName: '名',
      email: '邮箱',
      phone: '手机号码',
      areaCode: "区号",
      docType: '证件类型',
      idNum: '证件号码',
      legalInfo: '请填写法人代表信息',
      directorInfo: "请填写公司董事信息，请列举公司所有董事",
      upIDFront: '请上传本人身份证件（正面）',
      upIDBack: '请上传本人身份证件（反面）',
      upCorporate: '请上传法人身份证件（正面）',
      upCorporateBack: '请上传法人身份证件（反面）',
      upNatural: '',
      upNaturalBack: '',
      upTip: '+最终受益人（实际控制人或持股25%以上）',
      certificateIssuingPlace: '请选择证件签发地',
      gender: '性别',
      dateBirth: '出生日期',
      male: '男',
      female: '女',
      moreThanDirector: '公司董事',
      moreThanShareholding: '最终受益人（实际控制人或持股25%以上）',
      moreThanStockholder: '公司股东（实际控制人或持股25%以上）',
      email1: '请输入邮箱',
      emailFormat: '邮箱格式错误',
      directoreType: '公司董事类型',
      stockholderType: '公司股东类型',
      enterprise: '企业',
      personal: '个人',
      enterpriseName: '企业名称',
      enterpriseCertificate: '企业证件类型',
      enterpriseFile: '请上传企业证件',
      enterpriseCode: '企业证件编号',
      enterpriseLocation: '企业证件签发地',
      remark: '如有多位董事, 请列举所有董事的姓名',
      beneficiaryType: '最终受益人类型',
      updateUserTitle: '更新登录用户',
      updateUserTip1: '被授权人信息与系统留存登录用户信息不一致，请确认是否更新登录用户信息？',
      updateUserTip2: '点击确认，您的登录账号将更新为被授权人的邮箱或手机。',
      confirm: '确认',
      contactName: '姓名',
      certificateFrontTip: '请上传 证件（正面）',
      certificateBackTip: '请上传 证件（正面）'
    },
    openAccountForm: {
      tit: '请上传授权确认书',
      titTwo: '请同意签署授权确认书',
      downText: '下载模板',
      tip: '通过勾选此框及点击“提交”，您同意签署',
      checkServiceAgreement: '请先查看并勾选服务协议',
      agreement: '《CFCA数字证书服务协议》',
      subTip: '请上传授权确认书'
    },
    subSuccess: {
      success: '提交成功',
      tip: '我们的团队将在 24 小时内核实您的信息...',
      btnText: '返回首页',
    },
  },
  preApprovalLogin: {
    companyDetails: '企业详情',
    description: "了解您的业务性质有助于我们为您量身定制最适合您的融资方案。",
    monthlySales: '月销售额',
    businessScope: '经营范围',
    next: '下一步',
    select: '请选择',
    success: '成功',
    revenue: '验证您的收入 ',
    description2: '同步商业账户的销售数据有助于我们了解您的业务表现，并为您量身定制融资方案',
    commerceAccount: '添加平台账户',
    dataSynced: '成功同步了 {count} 个账户的数据',
    saleData: '我们要求您与我们同步销售数据以... ',
    fundApproval: '简化资金审批流程',
    fundApplication: '无需抵押！设置只需一分钟，即可轻松申请资金 ',
    financeSolution: ' 个性化融资方案',
    tailorProduct: '为您量身定制我们的融资产品',
    settlementData: '提供结算信息',
    description3: '结算数据或银行对账单可以提高您的申请成功率，并可能帮助您获得更高的信用额度',
    submitSuccess: '提交成功',
    emailTip: '我们正在审核您的申请，并将在24小时内通过电子邮件回复您',
    done: '完成',
    submit: '提交',
    logoutSuccess: '退出成功',
    salesPlatform: '选择销售平台',
    description4: '所有数据严格保密，将仅用于检查您是否符合融资资格',
    marketplace: '选择一个市场',
    platform: '平台',
    storeName: '店铺名称',
    area: '站点',
    status: '状态',
    file: '文件',
    uploadFile: '上传文件',
    proceed: '请继续上传',
    syncSuccess: '同步成功',
    continueTip: '请在 Chrome 插件中继续',
    continueTip2: '在我们的 Chrome 插件中继续操作以完成',
    continueTip3: '还未安装？点击下面的链接进行安装',
    appName: 'LLS融资助手',
    continueTip4: '如何使用?',
    continueTip5: '刷新数据',
    continueTip6: '技术支持?',
    copyLink: '链接已复制',
    monthlySalesMiss: '月销售额必填',
    businessScopeMiss: '经营范围必填'
  },
  message: {
    done: '标记完成',
    notificationsList: '消息列表',
    markAsDone: '标记完成',
    message: '消息',
    todo: '待办',
    day: '天',
    hour: '小时',
    minutes: '分钟',
    seconds: '秒',
    markAllAsRead: '全部已读',
    noMessages: '暂无消息',
    noMessagesTip: '新消息会显示在这里',
    noTodo: '暂无待办',
    noTodoTip: '新待办会显示在这里',
    end: '已展示全部',
    markAllAsDownloaded: '全部标记为已下载',
    loading: '加载中...',
    noMoreData: '没有更多数据了'
  }
}
